import { render, staticRenderFns } from "./PatientCardViewByQR.vue?vue&type=template&id=f25ebf8a"
import script from "./PatientCardViewByQR.vue?vue&type=script&lang=js"
export * from "./PatientCardViewByQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports